import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/a'
  },
  {
    name: 'a/:id',
    component: () => import('./view/home'),
    meta: {
      title: '河南良田优尚五金制造有限公司'
    }
  },
  {
    name: 'p/:id',
    component: () => import('./view/home/indexPac.vue'),
    meta: {
      title: '河南良田优尚五金制造有限公司'
    }
  },
  {
    name: '*/:id',
    component: () => import('./view/home'),
    meta: {
      title: '河南良田优尚五金制造有限公司'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
